module.exports = __webpack_public_path__ + "img/pong-screenshot.f303a500.png";